import Checkbox from 'antd/es/checkbox';
import 'antd/lib/checkbox/style';
export default Checkbox;
